export default __webpack_public_path__ + "files/facebook.png";